/** Amenity titles that are not available in every home. Matched case-insensitively. */
const SELECT_UNIT_AMENITY_TITLES = ['vinyl plank flooring'];

export function isSelectUnitAmenity(title: string | null | undefined): boolean {
  if (!title) return false;
  return SELECT_UNIT_AMENITY_TITLES.includes(title.trim().toLowerCase());
}
